import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { GA4 } from './models/ga4.model';
import { TagManagerConfig } from './models/tag-manager-config.model';


export const TAG_MANAGER_CONFIG = new InjectionToken<Promise<TagManagerConfig>>('TAG_MANAGER_CONFIG');
export const REFERRAL_URL = new InjectionToken<string>('REFERRAL_URL');
export const GA4_ITEMS_MAPPER = new InjectionToken<(...args) => Array<Omit<GA4.Item, '__event_name'>>>('GA4_ITEMS_MAPPER');
export const TRACKING_EVENTS = new InjectionToken<Observable<GA4.GA4>>('TRACKING_EVENTS');
export const TRACKING_TYPES = new InjectionToken<{ [key: string]: Observable<boolean> }>('ALLOWED_TRACKING_TYPES');

export function referralUrlOrDefault(url: string): URL {
    if (url)
        return new URL(url);
    let _referralUrl: URL;
    try {
        _referralUrl = new URL(window.location.toString());
        _referralUrl.hash = '';
    } catch {}
    return new URL(_referralUrl);
}
